import { Component, Vue, Prop } from 'vue-property-decorator'
import { ISelection, IPlaceRequest, IPlaceResult } from '@/store/modules/cart/interfaces'
import _ from 'lodash'
import { Multipliers, GetMultiplier, GetVisualMultiplier, StripTheGarbage, FormatDollars, GetSeasonFromYear, FormatCurrency, FormatEventName } from '@/utils/GameUtils';

@Component
export default class Cart extends Vue {
  private wagerOpts: number[] = [5, 10, 15, 25]
  private picks: ISelection[] = []

  private userAmount: number = 10
  private userAmountVis: string = this.userAmount.toFixed(2)
  private multipliers: number[] = Multipliers()

  private invalidState = true
  private isSubmitting = false

  private isClassic =  this.$store.getters.ISCLASSIC

  private ErrorMessageLookup: {[s: string]: string} = {
    '-1': 'There has been a problem placing your entry, please contact support',
    '5':  'Unable to authorise account. Please check your password and try again',
    '9':  'Unfortunately some of your choices are no longer avaliable, please make new selections',
    '13': 'You do not have enough funds for this entry, Please go to the My Account page where you can deposit funds',
    '17': 'In order to place an entry, you must select at least 3 Matchups. Please select additional players',
    '20': 'Due to regional restrictions we are unable to place tickets from your current location',
    '21': 'Location Services must be turned on to submit a ticket. You can enable this in',
    '22': `We're unable to validate your location. You may need to log out and log in again to place a bet`,
    '37': 'Max entry amount exceeded, please select a lower amount to play',
    '38': 'You have reached the maximum number of live tickets',
    '39': this.isClassic ? 'Players from at least three teams or two years are required in a ticket' : 'Players from a minimum of two events are required in a ticket',
    '41': 'Sorry, you have already picked this player or against this player. One player or opponent per ticket',
    '42': 'You have already picked some of those matchups in a previous ticket',
    '43': 'You have reached the max entry for this ticket. Please change at least one Matchup',
    '45': 'Sorry, you have already picked this player or against this player. One player or opponent per ticket',
    '44': 'Unfortunately some of your choices are no longer avaliable, please make new selections',
  }

  private created() {
    this.picks = this.$store.getters.SELECTIONS
  }

  private padPicksWithCallToAction(): ISelection[] {
    let padVals: ISelection[] = []
    const len = this.picks.length

    for (var i = 0; i < (10-len); i++) {
      const potentialWin = this.userAmount * this.multipliers[i+len];
      const suffix = potentialWin > 0 ? `to win $${potentialWin.toFixed(2)}` : 'to play'
      padVals.push({mode: 'msg', msg: `pick ${i+1} more ${suffix}`})
    }

    return padVals 
  }

  private submitClick() {
    if (this.isSubmitting) { return; }

    //@ts-ignore
    heap.track('cart:submit:init')

    this.isSubmitting = true;
    const req: IPlaceRequest = this.$store.getters.GET_PLACE_REQUEST(this.userAmount * 100)
    this.$store.dispatch('PROCESS_CART', req).then( (res: IPlaceResult) => {
      if (res.draft) {
        // @ts-ignore
        //this.$awn.success(`Ticket placed for ${FormatCurrency(this.userAmount)}!`)
        this.genDialog(`Ticket placed for ${FormatCurrency(this.userAmount)}!`, () => {
          this.$router.push('lobby')
        })
        // @ts-ignore
        this.$store.dispatch('SET_BALANCE', res.draft.balance)
        this.$store.dispatch('CLEAR_CART')

        //@ts-ignore
        heap.track('cart:submit:success')

        this.isSubmitting = false
        
      } else {
        // @ts-ignore
        const code = res.errorCode || -1
        let error = this.ErrorMessageLookup[code.toString()] || this.ErrorMessageLookup['-1']
        // @ts-ignore
        //this.$awn.alert(error)
        this.genDialog(error)

        //@ts-ignore
        heap.track('cart:submit:failure', {'error': code})

        if (res.errorList) {
          this.$store.dispatch('MARK_PICK_INVALID', res.errorList[0].split(','))
        }

        this.isSubmitting = false;
      }
    })
  }

  private genDialog(msg: string, cb: () => void) {
    this.$modal.show('dialog', {
      text: msg,
      buttons: [
        {
          title: 'Close',
          handler: () => { 
            this.$modal.hide('dialog') 
            if (cb) { cb() } 
          }
        }
     ],
    })
  }
  
  private removeClick(selection: ISelection) {
    this.$store.dispatch('REMOVE_PICK', selection)

    //@ts-ignore
    heap.track('draft:matchup:remove', {'matchup': selection.matchupId})
  }

  private wagerOptsClick(selection: number) {
    this.userAmountVis = selection.toFixed(2)
    this.userAmount = FormatDollars(this.userAmountVis)

    //@ts-ignore
    heap.track('draft:wager:option', {'amount': selection})
  }

  private render(h: any): any {

    this.invalidState = this.picks.length < 3
    const toRender: ISelection[] = _.concat(this.picks, this.padPicksWithCallToAction())

    const selections = toRender.map((select, idx) => {

      if (select.mode === 'msg') {
        return (
          <div class='draft-cart-list label'>
            <svg viewBox='0 0 200 200'>
                <use xlinkHref='#icon-logo'></use>
            </svg>
            <span class='draft-cart-multi'>{GetVisualMultiplier(idx) || '-'}</span>
            <router-link to='/lobby'>{select.msg}</router-link>
            <div class={`draft-cart-list-div div-${GetMultiplier(idx)}`}></div>
          </div>
        )
      } else if(select.mode === 'ou') {
        if (!select.pick) { return }
        if (!select.vs) { return }

        const visibleName = select.pick.player.name.toLowerCase() === 'under' ? select.vs.player.shortName : select.pick.player.shortName

        if (select.classic) {
          const pickYear = visibleName.substr(-4)

          return (
            <div class={`draft-cart-list label ou classic ${select.invalid ? 'invalid' : ''}`}>
              <svg viewBox='0 0 200 200'>
                  <use xlinkHref='#icon-logo'></use>
              </svg>
              <span class='draft-cart-multi'>{GetVisualMultiplier(idx) || '-'}</span>
              <div class='cart-pick-info'>
                <span class='cart-pick-name'>{visibleName.slice(0, -5)} {GetSeasonFromYear(pickYear)}</span>
              </div>

              <div class='cart-vs-info'>
                to score {select.oulabel} {select.ou}
              </div>

              <div class='cart-pick-info'></div>
              <div class='cart-vs-info empty'></div>

              <button class='cart-pick-right button-icon icon icon-close' onClick={this.removeClick.bind(this, select)}>
                <svg viewBox='0 0 200 200'>
                  <use xlinkHref='#icon-close'></use>
                </svg>
              </button>
              <div class={`draft-cart-list-div div-${GetMultiplier(idx)}`}></div>
            </div>
          )
        } else {
          return (
            <div class={`draft-cart-list label ou ${select.invalid ? 'invalid' : ''}`}>
              <svg viewBox='0 0 200 200'>
                  <use xlinkHref='#icon-logo'></use>
              </svg>
              <span class='draft-cart-multi'>{GetVisualMultiplier(idx) || '-'}</span>
              <div class='cart-pick-info'>
                <span class='cart-pick-name'>{visibleName}</span>, <span class='cart-pick-subinfo'>{select.pick.event.shortName}</span>
              </div>

              <div class='cart-vs-info'>
                to score {select.oulabel} {select.ou}
              </div>

              <div class='cart-pick-info'></div>
              <div class='cart-vs-info empty'></div>

              <button class='cart-pick-right button-icon icon icon-close' onClick={this.removeClick.bind(this, select)}>
                <svg viewBox='0 0 200 200'>
                  <use xlinkHref='#icon-close'></use>
                </svg>
              </button>
              <div class={`draft-cart-list-div div-${GetMultiplier(idx)}`}></div>
            </div>
          )
        }
      } else {
        // h2h
        if (!select.pick) { return }
        if (!select.vs) { return }

        if (select.classic) {
          const pickYear = select.pick.player.name.substr(-4)
          const vsYear = select.vs.player.name.substr(-4)

          return (
            <div class={`draft-cart-list label h2h classic ${select.invalid ? 'invalid' : ''}`}>
              <svg viewBox='0 0 200 200'>
                  <use xlinkHref='#icon-logo'></use>
              </svg>
              <span class='draft-cart-multi'>{GetVisualMultiplier(idx) || '-'}</span>
              <div class='cart-pick-info'>
                <span class='cart-pick-name'>
                  {select.pick.player.shortName.slice(0, -5)} {GetSeasonFromYear(pickYear)}
                </span>
              </div>

              <div class='cart-vs-info'>
                vs {select.vs.player.shortName.slice(0, -5)} {GetSeasonFromYear(vsYear)}
              </div>

              <div class='cart-pick-info'></div>
              <div class='cart-vs-info empty'></div>

              <button class='cart-pick-right button-icon icon icon-close' onClick={this.removeClick.bind(this, select)}>
                <svg viewBox='0 0 200 200'>
                  <use xlinkHref='#icon-close'></use>
                </svg>
              </button>
            </div>
          )
        } else {
          return (
            <div class={`draft-cart-list label h2h ${select.invalid ? 'invalid' : ''}`}>
              <svg viewBox='0 0 200 200'>
                  <use xlinkHref='#icon-logo'></use>
              </svg>
              <span class='draft-cart-multi'>{GetVisualMultiplier(idx) || '-'}</span>
              <div class='cart-pick-info'>
                <span class='cart-pick-name'>{select.pick.player.shortName}</span>, <span class='cart-pick-subinfo'>{FormatEventName(select.pick)}</span>
              </div>

              <div class='cart-vs-info'>
                vs {select.vs.player.shortName}
              </div>

              <div class='cart-pick-info'></div>
              <div class='cart-vs-info empty'></div>

              <button class='cart-pick-right button-icon icon icon-close' onClick={this.removeClick.bind(this, select)}>
                <svg viewBox='0 0 200 200'>
                  <use xlinkHref='#icon-close'></use>
                </svg>
              </button>
            </div>
          )
        }
      }
  });

    const amountOpts = this.wagerOpts.map((opt) => { return (
      <button class='fbutton button-action' onClick={this.wagerOptsClick.bind(this, opt)}>${opt}</button>
    )});

    let buttonContent = <span>Submit Ticket</span>

    if (this.isSubmitting) {
      buttonContent = <div class='lds-ellipsis'><div></div><div></div><div></div><div></div></div>
    }

    return (
      <div class='draft-cart'>

        {selections}

        <div class='draft-submit cart-submit'>
          <div class='draft-submit-panel'>
            <div class='button-bar light'>
              {amountOpts}
              <div class='input-wrapper'>
                <span class='input-prefix'>$</span>
                <input type='number' 
                  vModel={this.userAmountVis}
                  onKeyPress={StripTheGarbage.bind(this)}
                  onBlur={() => {
                    this.userAmount = FormatDollars(this.userAmountVis)
                  }}
                  step='any' min='0' class='fbutton finput button-action' name='customDraftFee'></input>
              </div>
            </div>
            <div class='draft-place'>
              <button onClick={this.submitClick.bind(this)} class='fbutton button-action wide' disabled={this.invalidState}>
                {buttonContent}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
